import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentPaymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type PaymentMethodProps = {
	userId: string;
	paymentMethodId: string;
	onSuccess?: Function;
	onError?: Function;
};

const useRemoveAgentPaymentMethod = ({ refetch }) => {
	const dispatch = useDispatch();

	return useMutation(
		({ userId, paymentMethodId }: PaymentMethodProps) => {
			return agentPaymentsService.deletePaymentMethod({
				userId,
				paymentMethodId,
			});
		},
		{
			onSuccess(result, { onSuccess }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Payment Method has been deleted",
					}),
				);
				onSuccess?.(result);
				refetch();
			},
			onError(error: ErrorResponse, { onError }) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useRemoveAgentPaymentMethod;
